import { IconButton } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Href } from "../../../../../../components/Href";
import { Icon } from "../../../../../../components/Icon";
import {
  getMenuItemAdapterType,
  getMenuItemAdapterValues,
} from "../../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 *
 * @param {Props} props
 */
export function MenuItem({ menuItem }) {
  const translate = useTranslate();

  if (getMenuItemAdapterType({ menuItem }) === undefined) {
    return null;
  }

  const { title, href, target, icon } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  if (!href || !icon) {
    return null;
  }

  return (
    <Href href={href} target={target}>
      <IconButton
        icon={<Icon icon={icon} size="1.125rem" />}
        variant="ghost"
        aria-label={title}
      />
    </Href>
  );
}
